import * as v from 'valibot';
import { t } from 'i18next';

export const CampaignCategoryFormSchema = v.object({
	name: v.pipe(
		v.string(t('Prosím nenechávejte toto pole prázdné.')),
		v.nonEmpty(t('Prosím nenechávejte toto pole prázdné.')),
	),
	color: v.nullable(v.string()),
});
